import { Routes, Route } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
// import DashboardPage from './pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import UnlockedContent from './pages/public/unlocked/category';
import LockedContent from './pages/public/locked';
import { DashboardLayout } from './layouts/DashboardLayout';
import Usersmanagement from './pages/public/usermanagement';
import CategoryDetailsPage from './pages/public/unlocked/categoryDetail';
import LockedContentDetail from './pages/public/locked/lockedContentDetail';
import UnLockedContentDetail from './pages/public/unlocked/contentDetail';
import AdminProfilePage from './pages/ProfilePage';
import AddNotification from './pages/public/AddNotification';
import AnalyticsPage from './pages/analytics/AnalyticsPage';
import UserActivityLogsPage from './pages/public/usermanagement/UserActivityLogsPage';
import GuestUsersPage from './pages/guest-users';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<AnalyticsPage />} />
          {/* <Route path="/dashboard" element={<DashboardPage />} /> */}
          <Route path="/profile" element={<AdminProfilePage />} />
          <Route path="/open-content" element={<UnlockedContent />} />
          <Route path="/open-content/:categoryId" element={<CategoryDetailsPage />} />
          <Route path="/open-content/:categoryId/:contentId" element={<UnLockedContentDetail />} />
          <Route path="/locked-content" element={<LockedContent />} />
          <Route path="/locked-content/:contentId" element={<LockedContentDetail />} />
          <Route path="/add-notification" element={<AddNotification />} />
          <Route path="/user-management" element={<Usersmanagement />} />
          <Route path="/user-management/:userId/logs" element={<UserActivityLogsPage />} />
          <Route path="/guest-users" element={<GuestUsersPage />} />
          {/* Analytics Routes */}
          <Route path="/analytics" element={<AnalyticsPage />} />
          {/* Settings Routes */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Form Examples */}
          <Route path="/forms" element={<SimpleFormPage />} />
          <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
